import { render } from "./UserAvatar.vue?vue&type=template&id=7ac2361a&scoped=true&ts=true"
import script from "./UserAvatar.vue?vue&type=script&lang=ts"
export * from "./UserAvatar.vue?vue&type=script&lang=ts"

import "./UserAvatar.vue?vue&type=style&index=0&id=7ac2361a&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac2361a"]])

export default __exports__